import { ActivityTab } from 'modals/JaneDetailsModal/views/JaneDetailsView/ActivityTab/ActivityTab';
import { GeneralTab } from 'modals/JaneDetailsModal/views/JaneDetailsView/GeneralTab/GeneralTab';
import { ReviewsTab } from 'modals/JaneDetailsModal/views/JaneDetailsView/ReviewsTab/ReviewsTab';
export const JaneDetailViewComponentMap = {
  GeneralTab,
  ReviewsTab,
  ActivityTab,
};

export type JaneDetailsViewActiveTabType = keyof typeof JaneDetailViewComponentMap;
